import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})
export class PdfGeneratorService {

  constructor() { }

  // generatePdfHtml(table: any, fileName: string, info: string = ""): void {
  //   const doc = new jsPDF({
  //     orientation: 'landscape'
  //   });
  //   const dateGenerated = new Date();
  //   const dateGenString = "Generated on "
  //     + dateGenerated.toISOString().slice(0, 10) + " "
  //     + dateGenerated.getHours() + ":"
  //     + dateGenerated.getMinutes() + ":"
  //     + dateGenerated.getSeconds();
  //   const img = new Image()
  //   img.src = "assets/vertex_pdf_header.png"


  //   // For finding page dimensions
  //   const pageSize = doc.internal.pageSize;
  //   const pageHeight = pageSize.getHeight()
  //   const pageWidth = pageSize.getWidth()

  //   doc.addImage(img, "jpg", 25, 10, pageWidth - 50, 240);

  //   // For adding heading
  //   const headingTitle = fileName.split("_").map(each => { return each.charAt(0).toUpperCase() + each.slice(1) })
  //   doc.text(headingTitle.join(" "), 31, 85);

  //   // For adding subheading data
  //   doc.setFontSize(10)
  //   doc.text(info, 31, 95)

  //   autoTable(doc, {
  //     html: table,
  //     startY: 100,
  //     styles: { halign: 'center' },
  //     headStyles: { fillColor: [103, 104, 116] },
  //   });

  //   for (var i = 1; i <= doc.getNumberOfPages(); i++) {
  //     doc.setPage(i);

  //     // For adding footer
  //     doc.text(`OnDRM Console v${localStorage.getItem('version')}`, 31, pageHeight - 10)

  //     // For Page Number
  //     doc.text(`Page ${i}`, Math.round(pageWidth / 2), pageHeight - 10)

  //     // For adding subfooter date
  //     doc.text(dateGenString, pageWidth - 85, pageHeight - 10)
  //   }

  //   doc.save(fileName + '_' + dateGenerated.getTime());
  // }
  generatePdfHtml(table: any, fileName: string, info: string = ""): void {
    const doc = new jsPDF({
      orientation: 'landscape'
    });
    const dateGenerated = new Date();
    const dateGenString = "Generated on "
      + dateGenerated.toISOString().slice(0, 10) + " "
      + dateGenerated.getHours() + ":"
      + dateGenerated.getMinutes() + ":"
      + dateGenerated.getSeconds();
    const img = new Image();
    img.src = "assets/vertex_pdf_header.png";
  
    // For finding page dimensions
    const pageSize = doc.internal.pageSize;
    const pageHeight = pageSize.getHeight();
    const pageWidth = pageSize.getWidth();
  
    // Adjusted Image Dimensions
    const imgWidth = 250; // Adjust as needed
    const imgHeight = 60; // Adjust as needed
    const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
  
    doc.addImage(img, "jpg", imgX, imgY, imgWidth, imgHeight);
  
    // For adding heading
    const headingTitle = fileName.split("_").map(each => {
      return each.charAt(0).toUpperCase() + each.slice(1);
    });
    doc.text(headingTitle.join(" "), 31, 85);
  
    // For adding subheading data
    doc.setFontSize(10);
    doc.text(info, 31, 95);
  
    autoTable(doc, {
      html: table,
      startY: 100,
      styles: { halign: 'center' },
      headStyles: { fillColor: [103, 104, 116] },
    });
  
    for (var i = 1; i <= doc.getNumberOfPages(); i++) {
      doc.setPage(i);
  
      // For adding footer
      doc.text(`OnDRM Console v${localStorage.getItem('version')}`, 31, pageHeight - 10);
  
      // For Page Number
      doc.text(`Page ${i}`, Math.round(pageWidth / 2), pageHeight - 10);
  
      // For adding subfooter date
      doc.text(dateGenString, pageWidth - 85, pageHeight - 10);
    }
  
    doc.save(fileName + '_' + dateGenerated.getTime());
  }
  
}
